// extracted by mini-css-extract-plugin
export default {"sign":"style_sign__qhJqd"};